export default __webpack_public_path__ + "static/media/notfound.b3112942.png";